import {SchedulerSettingsResponse, SchedulerSettingsResponseItem} from '@/types/service-response'

export class SchedulerSettings {
  private constructor (
    readonly code: string,
    readonly value: boolean,
    readonly description: string
  ) {}

  public static createListFromResponse (data: SchedulerSettingsResponse): SchedulerSettings[] {
    const filteredData: SchedulerSettingsResponseItem[] =  []
    data.forEach((item: SchedulerSettingsResponseItem) => {
      const foundItem: SchedulerSettingsResponseItem | undefined = filteredData.find((i: SchedulerSettingsResponseItem) => i.Code === item.Code)
      if(foundItem && item.Mitarbeiter !== 0) {
        const index: number = filteredData.indexOf(foundItem)
        filteredData[index] = item
      } else {
        filteredData.push(item)
      }
    })
    return filteredData.map((item: SchedulerSettingsResponseItem): SchedulerSettings => {
      return new SchedulerSettings(
        item.Code,
        item.SettingValue === '1',
        item.Bezeichnung
      )
    })
  }
}
